import Translations from "../utils/translations";
import DetectMobileBrowsers from "./detect-mobile-browsers";

class CartShort {
    constructor() {
        this.t = new Translations();
        this.cartShortItems = $(".cart-short__items");
        this.cartCounter = $("#cart-counter");
        this.cartShortCounter = $("#cart-short-counter");
        this.cartAmount = $("#cart-amount");
        this.cartSummary = $(".short-cart-summary .price");
        this.cartSummaryContent = $(".short-cart-summary .content");
        this._data = null;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
        //console.log(this.data);
        this.renderHTML();
    }

    renderHTML() {
        if (this.data.hasOwnProperty("numerowane")) {
            this.renderTicketsHTML();
        }

        /*if (this.data.hasOwnProperty("wycieczki")) {
          this.renderToursHTML();
        }*/

        if (this.data.hasOwnProperty("towary")) {
            this.renderProductsHTML();
        }

        if (
            this.data.hasOwnProperty("liczba_biletow") ||
            this.data.hasOwnProperty("liczba_towarow")
        ) {
            this.renderCartCounter();
            this.renderCartShortCounter();
            this.toggleCartSummaryContent();
        }

        if (this.data.hasOwnProperty("koszyk_razem")) {
            this.renderCartAmount();
            this.renderCartSummary();
        }
    }

    renderTicketsHTML() {
        const _this = this;
        let tickets = this.data.numerowane;
        let shortCartTickets = $("#short-cart-tickets");
        let currency = this.data.waluta;
        let html = ``;

        function renderShortCartItemContent(term, currency) {
            let termName = term.wydarzenie_nazwa;
            let tickets = term.wybrane_bilety;
            let numberOfTickets = 0;
            let ticketsPrice = 0;
            let image = term.zdjecie_sciezka;
            let html = ``;

            for (const key in tickets) {
                if (tickets.hasOwnProperty(key)) {
                    const ticket = tickets[key];

                    numberOfTickets += ticket.length;
                    ticket.forEach(element => {
                        ticketsPrice += parseFloat(element.cena);
                    });
                }
            }

            html += `<div class="short-cart-item__content">
                 <div class="img-box">
                   <img src="${image}" alt="${termName}">
                 </div>
                 <div class="content-box">
                   <div class="name">${termName}</div>
                   <div class="price">${ticketsPrice.toFixed(
                2
            )} ${currency}</div>
                   <div class="num-box">
                     <span class="num-txt">${_this.t.get("_liczba")}:</span>
                     <span class="num">${numberOfTickets}</span>
                   </div>
                 </div>
               </div>`;

            return html;
        }

        if (tickets.length > 0) {
            html += `<div id="short-cart-tickets" class="short-cart-item">
                 <div class="short-cart-item__header">${_this.t.get(
                "_bilety"
            )}</div>`;

            tickets.forEach(term => {
                html += `<div class="short-cart-item__date">${
                    term.termin_data_sformatowana
                } godz. ${term.termin_godzina}</div>${renderShortCartItemContent(
                    term,
                    currency
                )}`;
            });

            html += `</div>`;
        }

        if (shortCartTickets.length > 0) {
            shortCartTickets.replaceWith(html);
        } else {
            this.cartShortItems.append(html);
        }
    }

    renderToursHTML() {
        let tours = this.data.wycieczki;
        let shortCartTours = $("#short-cart-tours");
        let html = ``;

        function renderShortCartItemContent(tour) {
            let ticketsInGroup = tour.bilety.bilety_w_grupie;
            let name = tour.nazwa_wydarzenia;
            html = ``;

            ticketsInGroup.forEach(function (ticket) {
                html += `<div class="short-cart-item__content">
                   <div class="img-box">
                     <img src="/assets/images/wycieczka.png" alt="${name}">
                   </div>
                   <div class="content-box">
                     <div class="name">${name}</div>
                     <div class="price">${ticket.wartosc}</div>
                     <div class="num-box">
                       <span class="num-txt">${_this.t.get("_liczba")}:</span>
                       <span class="num">${ticket.ilosc}</span>
                     </div>
                   </div>
                 </div>`;
            });

            return html;
        }

        if (!Array.isArray(tours)) {
            html += `<div id="short-cart-tours" class="short-cart-item">
                 <div class="short-cart-item__header">${_this.t.get(
                "_wycieczki"
            )}</div>`;

            for (const key in tours) {
                if (tours.hasOwnProperty(key)) {
                    const tour = tours[key];

                    html += `<div class="short-cart-item__date">${
                        tour.data_sformatowana
                    } godz. ${tour.godzina_terminu}</div>${renderShortCartItemContent(
                        tour
                    )}`;
                }
            }

            html += `</div>`;
        }

        if (shortCartTours.length > 0) {
            shortCartTours.replaceWith(html);
        } else {
            this.cartShortItems.append(html);
        }
    }

    renderProductsHTML() {
        const _this = this;
        let products = this.data.towary;
        let shortCartProducts = $("#short-cart-products");
        let html = ``;

        function renderShortCartItemContent(product) {
            return `<div class="short-cart-item__content">
                 <div class="img-box"><img src="${product.zdjecie_min}" alt="${
                product.nazwa
            }"></div>
                 <div class="content-box">
                   <div class="name">${product.nazwa}</div>
                   <div class="price">${product.cena}</div>
                   <div class="num-box">
                     <span class="num-txt">${_this.t.get("_liczba")}:</span>
                     <span class="num">${product.ilosc}</span>
                   </div>
                 </div>
               </div>`;
        }

        if (!Array.isArray(products)) {
            html += `<div id="short-cart-products" class="short-cart-item">
                 <div class="short-cart-item__header">${_this.t.get(
                "_produkty"
            )}</div>`;

            for (const key in products) {
                if (products.hasOwnProperty(key)) {
                    const product = products[key];

                    html += `${renderShortCartItemContent(product)}`;
                }
            }

            html += `</div>`;
        }

        if (shortCartProducts.length > 0) {
            shortCartProducts.replaceWith(html);
        } else {
            this.cartShortItems.append(html);
        }
    }

    renderCartCounter() {
        const isMobileBrowser = DetectMobileBrowsers.check();
        let numberOfTickets = this.data.liczba_biletow;
        let numberOfProducts = this.data.liczba_towarow;

        this.cartCounter.text(numberOfTickets + numberOfProducts);

        if (isMobileBrowser) {
            this.cartCounter.parents(".fr-cart.disabled").removeClass("disabled");
        }
    }

    renderCartShortCounter() {
        let numberOfTickets = this.data.liczba_biletow;
        let numberOfProducts = this.data.liczba_towarow;

        this.cartShortCounter.text(numberOfTickets + numberOfProducts);
    }

    renderCartAmount() {
        let amount = this.data.koszyk_razem;
        let currency = this.data.waluta;

        this.cartAmount.text(amount + " " + currency);
    }

    renderCartSummary() {
        let amount = this.data.koszyk_razem;
        let currency = this.data.waluta;

        this.cartSummary.text(amount + " " + currency);
    }

    toggleCartSummaryContent() {
        let numberOfTickets = this.data.liczba_biletow;
        let numberOfProducts = this.data.liczba_towarow;

        if (numberOfTickets + numberOfProducts === 0) {
            this.cartSummaryContent.addClass("d-none");
        } else {
            this.cartSummaryContent.removeClass("d-none");
        }
    }
}

export default CartShort;
